React = require('react/addons')
EventActions = require '../../actions/EventActions'

module.exports = React.createClass
    mixins: [React.addons.LinkedStateMixin]

    getInitialState: ->
        {
            selected : {
                active: true
            }
        }

    onShowAll: (e) ->
        e.preventDefault()

        EventActions.get('all')

        @setState({
            selected : {
                all: true
            }
        })


    onShowActive: (e) ->
        e.preventDefault()

        EventActions.get('active')

        @setState({
            selected : {
                active: true
            }
        })

    onShowExpire: (e) ->
        e.preventDefault()

        EventActions.get('expire')

        @setState({
            selected : {
                expire: true
            }
        })

    render: ->
        cx = React.addons.classSet

        showAllClass = cx({
            'option': true
            'active': @state.selected.all
        })

        showActiveClass = cx({
            'option': true
            'active': @state.selected.active
        })

        showExpireClass = cx({
            'option': true
            'active': @state.selected.expire
        })

        React.createElement("div", null,
            React.createElement("p", {"className": "tips"}, "Tips: Notes created will be expired in 2 days"),
            React.createElement("ul", {"className": "filter"},
                React.createElement("li", null, "Filter: "),
                React.createElement("li", {"className": (showAllClass), "onClick": (@onShowAll)}, "All"),
                React.createElement("li", {"className": (showActiveClass), "onClick": (@onShowActive)}, "Active"),
                React.createElement("li", {"className": (showExpireClass), "onClick": (@onShowExpire)}, "Expired")
            )
        )



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/components/modules/event-filter.cjsx
 **/